import React from 'react';
import classnames from 'classnames';
import Sticky from '@wix/da-ds/pkg/Sticky';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';

import s from './WidgetHeaderWide.scss';

export interface Props {
  header: string | React.ReactNode;
  extras?: React.ReactNode | React.ReactNode[];
  extrasWhenSticky?: React.ReactNode | React.ReactNode[];
  subHeader?: string;
  className?: string;
  isSticky?: boolean;
  bigger?: boolean;
}

const WidgetHeaderWide: React.FC<Props> = ({
  header,
  subHeader,
  extras,
  extrasWhenSticky,
  className,
  isSticky = false,
  bigger,
}) => {
  const renderInner = (isStuck = false) => {
    return (
      <div className={classnames(s['root'], isStuck && s['root-stuck'], className)}>
        <Heading className={classnames(s['header'], bigger && s['bigger-header'])}>
          {header}
        </Heading>
        {subHeader && <div className={s['sub-header']}>{subHeader}</div>}
        {isStuck ? extrasWhenSticky : extras}
      </div>
    );
  };

  return isSticky ? (
    <Sticky className={s['sticky']} marginTop={54}>
      {isStuck => renderInner(isStuck)}
    </Sticky>
  ) : (
    renderInner()
  );
};

export default WidgetHeaderWide;
